import { RootAppState } from 'store/configureStore'

/**
 * A project is empty if it has no part types ids in partTypeIds array
 */
export const ProjectIsEmptySelector = (state: RootAppState): boolean => {
  return !state.project.partTypeIds?.length
}
